import { PAYMENT_REQUESTED, PAYMENT_SUCCESS, PAYMENT_FAILED } from '../reducers/payments';

export const getPaymentByOrderId = (orderId) => {
  return (dispatch, getState, api) => {
    dispatch({ type: PAYMENT_REQUESTED });

    return api.get(`/payment/${orderId}`)
      .then((response) => {
        const state = getState();
        dispatch({
          type: PAYMENT_SUCCESS,
          payload: {
            [orderId]: {
              ...state.payments.data[orderId],
              ...response,
            },
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: PAYMENT_FAILED,
          payload: err.body.errorMessage,
        });
      });
  };
};

export const getPaymentStatus = (orderId) => {
  return (dispatch, getState, api) => {
    return api.get(`/payment/${orderId}/status`)
      .then((response) => {
        const state = getState();

        dispatch({
          type: PAYMENT_SUCCESS,
          payload: {
            [orderId]: {
              ...state.payments.data[orderId],
              redirectTo: response.redirectTo,
              html: response.html,
            },
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: PAYMENT_FAILED,
          payload: err.body.errorMessage,
        });
      });
  };
};

export const getPaymentHistory = (query) => {
  return (dispatch, _, api) => {
    return api.get(`/payment?${new URLSearchParams(query).toString()}`);
  };
};

export const createPayment = (query, data, headers = {}) => {
  return (dispatch, _, api) => {
    const queryString = new URLSearchParams(query).toString();
    return api.post(`/payment?${queryString}`, data, headers);
  };
};

export const getPaymentOptions = () => {
  return (dispatch, _, api) => {
    return api.get('/payment/options');
  };
};

export default {
  getPaymentByOrderId,
  getPaymentStatus,
  getPaymentHistory,
  createPayment,
  getPaymentOptions,
};
